<template>
    <p :class="pClass">
        <input type="checkbox"
               :id="id"
               :name="name"
               :value="val"
               v-model="checked"
               @change="onChange"
               :disabled="disabled"
        >
        <label :for="id" :class="{disabled: disabled}">
            <slot></slot>
        </label>
    </p>
</template>

<script>
	export default {
		name: "FilterCheckbox",
		props: {
			id: [String, Number],
			name: String,
			val: [String, Number, Boolean, Array],
			value: [String, Number, Boolean, Array],
			pClass: {
				type: String,
				default: 'field'
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		data: function () {
			return {
				checkedProxy: false
			}
		},
		computed: {
			checked: {
				get() {
					return this.value
				},
				set(val) {
					this.checkedProxy = val
				}
			}
		},
		methods: {
			onChange: function (e) {
				this.$emit('input', this.checkedProxy)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/FilterCheckbox.vue